/**
 * Program: Clear Cache service
 * Author: SDL
 * Description: Clear Cache service
 */
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';

export default {
  async clearCache() {
    await axios.get(`${SDLUtil.API_URL}/caches/clear-all`);
  },
};



// WEBPACK FOOTER //
// ./src/service/cacheService.js